import React from 'react';
import { X, Trash2 } from 'lucide-react';
import Button from './Button';
import { useTranslation } from 'react-i18next';


const ConfirmDialog = ({ open, title, message, onCancel, onConfirm }) => {

  const { t } = useTranslation();

  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel(); 
    }
  };
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white rounded-lg shadow-lg max-w-sm w-full p-5 border border-gray-200 relative"
        onClick={(e) => e.stopPropagation()}  
      >
        {/* Nút đóng */}
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          onClick={onCancel}
        >
          <X className="w-4 h-4" />
        </button>

        {/* Tiêu đề */}
        <div className="flex items-center mb-4">
          <Trash2 className="h-5 w-5 text-red-500 mr-2" />
          <h3 className="text-sm font-semibold text-gray-900">{title || "Xác nhận"}</h3>
        </div>

        {/* Nội dung */}
        <p className="text-sm text-gray-700 mb-5">{message}</p>

        {/* Nút hành động */}
        <div className="flex justify-end space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onCancel}
            className="text-gray-600 border-gray-300"
          >
            {t('confirm.cancel')}
          </Button>
          <Button
            size="sm"
            onClick={() => {
              onConfirm();
              onCancel();
            }}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            {t('confirm.delete')}
          </Button>
        </div>
      </div>
    </div>
  );
};


export default ConfirmDialog;
